import React from "react";

export default function Decorations(){
    return(
        <>
            <div className="parallax__layer parallax__layer__0">
                <img src="./images/dei-logo-x.png" width="3000" hspace="0" vspace="0" alt="Choose Your D E I Adventure" />
            </div>
            <div className="parallax__layer parallax__layer__3">
                <img src="./images/dei_site_layer_mtn_y.png?raw=true" alt="Let the journey begin" />
            </div>
            <div className="parallax__layer parallax__layer__6">
                <img src="./images/dei_site_layer_trees_x.png" alt="Into the Woods" />
            </div>
        </>
    );
}